function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import dc from 'dc';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { TileMixin } from '../Mixins/TileMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { AVIChartTile } from './../../Layout/AVIChartTile/AVIChartTile';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
import '../Charts.scss';
import './LineChart.scss';
export var LineChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LineChart, _Component);

  function LineChart(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.legendRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = LineChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.brushing = function brushing() {
    var _this2 = this;

    if (this.props.onBrushStart && this.props.onBrushEnd) {
      var oldBrushing = this.chart._brushing;

      this.chart._brushing = function () {
        if (!d3.event.sourceEvent) return;

        if (d3.event.sourceEvent.type && ['start', 'brush', 'end'].indexOf(d3.event.sourceEvent.type) !== -1) {
          return;
        }

        if (d3.event.sourceEvent.type === 'mousedown' || d3.event.sourceEvent.type === 'touchstart') {
          _this2.props.onBrushStart();
        }

        if (d3.event.sourceEvent.type === 'mouseup' || d3.event.sourceEvent.type === 'touchend') {
          _this2.props.onBrushEnd();

          _this2.chart._invokeFilteredListener(_this2.chart.filters());

          return;
        }

        oldBrushing();
      };
    }
  };

  _proto.mountCompositionChart = function mountCompositionChart() {
    var _this3 = this;

    this.chart = dc.compositeChart(this.chartRef.current);
    var compose = this.props.compose;

    if (this.props.composeSort) {
      compose = this.props.compose.sort(this.props.composeSort);
    }

    var lineCharts = compose.map(function (chartData) {
      var lineChart = dc.lineChart(_this3.chart);
      BaseMixin(lineChart, chartData);
      CapMixin(lineChart, chartData);
      ColorMixin(lineChart, chartData);
      TileMixin(lineChart, chartData);
      CoordinateGridMixin(lineChart, chartData);
      lineChart.legendName = chartData.legendName;

      for (var key in chartData) {
        if (typeof lineChart[key] == 'function') {
          lineChart[key](chartData[key]);
        }
      }

      return lineChart;
    });
    BaseMixin(this.chart, this.props, true);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    MarginsMixin(this.chart, this.props);
    CoordinateGridMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    var _this$props = this.props,
        x = _this$props.x,
        xUnits = _this$props.xUnits,
        showLegend = _this$props.showLegend,
        legend = _this$props.legend,
        _this$props$shareTitl = _this$props.shareTitle,
        shareTitle = _this$props$shareTitl === void 0 ? true : _this$props$shareTitl;
    this.chart.elasticY(true).x(x || d3.scaleBand()).xUnits(xUnits).compose(lineCharts).shareTitle(shareTitle);
    this.brushing();

    if (showLegend) {
      this.chart.legend(dc.htmlLegend().container(this.legendRef.current).legendItemClass('legend-item').legendText(function (d, v) {
        return d.chart.legendName;
      }));
    }

    if (legend) {
      this.chart.legend(legend());
    }

    this.chart.render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.legend !== this.props.legend) {
      this.chart.legend(this.props.legend()).render();
    }

    if (this.props.compose && prevProps.compose !== this.props.compose) {
      return this.mountCompositionChart();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.compose) {
      return this.mountCompositionChart();
    }

    this.chart = dc.lineChart(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    MarginsMixin(this.chart, this.props);
    CoordinateGridMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    var _this$props2 = this.props,
        curve = _this$props2.curve,
        dashStyle = _this$props2.dashStyle,
        dotRadius = _this$props2.dotRadius,
        renderArea = _this$props2.renderArea,
        renderDataPoints = _this$props2.renderDataPoints,
        xyTipsOn = _this$props2.xyTipsOn,
        x = _this$props2.x,
        xUnits = _this$props2.xUnits,
        showLegend = _this$props2.showLegend,
        legend = _this$props2.legend;
    this.chart.curve(curve).dashStyle(dashStyle).dotRadius(dotRadius).renderArea(renderArea).renderDataPoints(renderDataPoints).xyTipsOn(xyTipsOn).elasticY(true).x(x || d3.scaleBand()).xUnits(xUnits);

    if (showLegend) {
      this.chart.legend(dc.htmlLegend().container(this.legendRef.current).legendItemClass('legend-item').legendText(function (d, v) {
        return d.chart.legendName;
      }));
    }

    if (legend) {
      this.chart.legend(legend());
    }

    this.chart.render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        showLegend = _this$props3.showLegend,
        children = _this$props3.children;
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart chart line-chart',
      ref: this.chartRef
    }), /*#__PURE__*/React.createElement("div", {
      className: ['avi-chart', 'legend', showLegend ? 'show' : ''].join(' '),
      ref: this.legendRef
    }), children);
  };

  return LineChart;
}(Component);

_defineProperty(LineChart, "defaultProps", {
  curve: d3.curveLinear,
  dashStyle: [],
  dotRadius: 5,
  renderArea: false,
  renderDataPoints: {
    fillOpacity: 0.8,
    strokeOpacity: 0.0,
    radius: 2
  },
  xyTipsOn: true,
  //x: d3.scaleBand,
  xUnits: dc.units.ordinal
});

LineChart.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Gets or sets the curve factory to use for lines and areas drawn, allowing e.g. step functions, splines, and cubic interpolation. Typically you would use one of the interpolator functions provided by d3 curves. Replaces the use of dc.lineChart#interpolate and dc.lineChart#tension in dc.js < 3.0 This is passed to line.curve and area.curve. */
  curve: PropTypes.func,

  /** Set the line's d3 dashstyle. This value becomes the 'stroke-dasharray' of line. Defaults to empty array (solid line).*/
  dashStyle: PropTypes.array,

  /** Get or set the radius (in px) for dots displayed on the data points.*/
  dotRadius: PropTypes.number,

  /** Get or set render area flag. If the flag is set to true then the chart will render the area beneath each line and the line chart effectively becomes an area chart. */
  renderArea: PropTypes.bool,

  /** Always show individual dots for each datapoint.If options is falsy, it disables data point rendering. If no options are provided, the current options values are instead returned. */
  renderDataPoints: PropTypes.object,

  /** Turn on/off the mouseover behavior of an individual data point which renders a circle and x/y axis dashed lines back to each respective axis. This is ignored if the chart brush is on */
  xyTipsOn: PropTypes.bool,

  /** Set or get the xUnits function. The coordinate grid chart uses the xUnits function to calculate the number of data projections on the x axis such as the number of bars for a bar chart or the number of dots for a line chart. This function is expected to return a Javascript array of all data points on the x axis, or the number of points on the axis. d3 time range functions d3.timeDays, d3.timeMonths, and d3.timeYears are all valid xUnits functions. dc.js also provides a few units function, see the Units Namespace for a list of built-in units functions. Note that as of dc.js 3.0, dc.units.ordinal is not a real function, because it is not possible to define this function compliant with the d3 range functions. It was already a magic value which caused charts to behave differently, and now it is completely so. */
  xUnits: PropTypes.func,

  /** Get or set the x scale. The x scale can be any `d3` `d3.scale` or `ordinal scale` */
  x: PropTypes.func,

  /** Key name of the chart used by `AVIDashboardContext` in terms of the mapping name and id in the `register` method */
  name: PropTypes.string,

  /** Set to render legends in a separate collapsible div */
  showLegend: PropTypes.bool,

  /** Use dc legend og dc.htmlLegend to render legends, could be combined with showLegend, if not legend container is renderd as children */
  legend: PropTypes.func,

  /** Render optional components as children of chart. e.g. own handling of legends */
  children: PropTypes.any,
  onBrushStart: PropTypes.func,
  onBrushEnd: PropTypes.func,

  /** Set the margins for a particular coordinate grid chart instance. The margins is stored as array. */
  margins: PropTypes.array,

  /** Set the x axis label. */
  xAxisLabel: PropTypes.string,

  /** Set the x axis label padding. If setting the label, you may optionally include additional padding to the margin to make room for the label. By default the padded is set to 12 to accomodate the text height. */
  xAxisLabelPadding: PropTypes.number,

  /** Set the y axis label. */
  yAxisLabel: PropTypes.string,

  /** Set the y axis label padding. If setting the label, you may optionally include additional padding to the margin to make room for the label. By default the padded is set to 12 to accomodate the text height. */
  yAxisLabelPadding: PropTypes.number
} : {};
export default withAVIDashboardContext(LineChart);